const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;//'https://localhost:7228'; // Replace with your actual API base URL




export default API_BASE_URL;